import { initSentry, mockSentry } from './real-user-metrics'

try {
  initSentry()
} catch (e) {
  console.error('Failed to initialize Sentry', e)
  mockSentry()
}
